import { Model } from "@/core/magnet";

export default Model.extend({
  urlRoot: "interests",
  parse: function (response) {
    return response.data;
  },
});
